<cc-dropdown-input
  ngDefaultControl
  class="w-45"
  [elements]="allTimezones"
  [formControl]="formControl"
></cc-dropdown-input>
